<template>
  <v-row v-if="items">
        <v-col v-for="(i, index) in items" :key="`innere-${index}`" cols="6">
          <travel-site :item="i"></travel-site>
        </v-col>
  </v-row>

</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
import TravelSite from "./TravelSite"
import lodash from "lodash";

export default {
  name: "TravelResults",
  data() {
    return {
      obj: null,
      items: null
    };
  },
  components: {
    TravelSite
  },
  props: {
    uid: String,
    pid: String,
    doc: Object,
  },
  mounted() {
    this.getExercise();
  },
  methods: {
    getExercise() {
      console.log("get exercise");
      let item = fb.travelExCollection
        .where("uid", "==", this.uid)
        .where("pid", "==", this.pid);
      item.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        if (items.length) {
          this.obj = items[0];
          let entries = [];
          Object.values(this.obj.doc).forEach((value) => {
            entries.push(value)
          })
          this.items = lodash.orderBy(entries, "index", "asc");
        }
      });
    },
  },
};
</script>